import React, { Component } from 'react';
import { dashboardActions, userActions, alertActions, hospitalActions } from '../../_actions';
import { connect } from 'react-redux';
import LoadingOverlay from 'react-loading-overlay';
import moment from 'moment';
import jsPDF from "jspdf";
import "jspdf-autotable";
import ReactECharts from 'echarts-for-react';
import { Table, TableHead, TableBody, TableRow, TableCell, Button } from '@mui/material';
import { confirmAlert } from 'react-confirm-alert';
import ReactPaginate from 'react-paginate';
import { isMobile } from "react-device-detect";
import HospitalSidebar from '../../components/HospitalSidebar/HospitalSidebar';
import AddDoctorModel from './components/AddDoctorModel';
import UpdateDrModel from './components/UpdateDrModel';
import ViewMoreModel from './components/ViewMoreModel';
import { FaRegEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { BsThreeDots } from "react-icons/bs";

class HospitalDashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      pageNo: 1,
      size: 10,
      priceTempData: {
        BPC: 1,
        btcPrice: 0,
        dollerPrice: 0,
      },
      fieldslogin: {},
      errorslogin: {},
      option: {},
      fieldsUser: {},
      addDocotor: false,
      open: false,
      viewmore: false,
      size: 10,
      modelData: {},
      keyWord: ""
    }
  }

  componentDidMount() {
    let data = {
      "keyWord": "",
      "pageNo": 1,
      "size": 10
    }

    let dataCmc = {
      "keyWord": "",
      "pageNo": 1,
      "size": 12
    }
    let data2 = {
      "keyWord": "",
      "pageNo": 1,
      "size": 5
    }

    let type = {
      type: "HOSPITAL"
    }

    this.props.dispatch(hospitalActions.getHospitalProfile(data));
    this.props.dispatch(hospitalActions.getHospitalDrList(data));
    this.props.dispatch(hospitalActions.SpecializationIdHospital(type));

    window?.scrollTo(0, 0)

  }

  static getDerivedStateFromProps(nextProps, prevState) {

    if (nextProps.users.sendCoinSuccess) {
      return {
        ...nextProps,
        fieldslogin: {},
        errorslogin: {}
      }
    } else {
      return {
        ...nextProps
      }
    }
  }
  handlePageClick = (data) => {
    let offset = Math.ceil(data.selected * this.state.size);
    this.setState({ offset: offset, page: data.selected });
    let datatemp = {
      "size": this.state.keyWord,
      "keyWord": "",
      "pageNo": data.selected + 1,
      "size": 10
    }
    this.props.dispatch(hospitalActions.getHospitalDrList(datatemp));
  }

  handlePageClick = (data) => {

    console.log('Page clicked:', data.selected + 1);
    let datas = {
      "keyWord": "",
      "pageNo": data.selected + 1,
      "size": 10
    }

    this.props.dispatch(hospitalActions.getHospitalDrList(datas));
  };
  handleValidationSendCoin = () => {
    let fieldslogin = this.state.fieldslogin;
    let errorslogin = {};
    let formIsValid = true;

    //coinType
    if (!fieldslogin["coinType"]) {
      formIsValid = false;
      errorslogin["coinType"] = "Please select Coin Type!";
    }
    //toAddress
    if (!fieldslogin["toAddress"]) {
      formIsValid = false;
      errorslogin["toAddress"] = "Please Enter To Address";
    }
    //amount
    if (!fieldslogin["amount"]) {
      formIsValid = false;
      errorslogin["amount"] = "Please enter Amount!";
    }
    //fees
    if (!fieldslogin["fees"]) {
      formIsValid = false;
      errorslogin["fees"] = "Please enter Fees!";
    }
    //password
    if (!fieldslogin["password"]) {
      formIsValid = false;
      errorslogin["password"] = "Please enter Password!";
    }
    //recievingAmount
    if (!fieldslogin["recievingAmount"]) {
      formIsValid = false;
      errorslogin["recievingAmount"] = "Please enter RecievingAmount!";
    }

    this.setState({ errorslogin: errorslogin });
    return formIsValid;
  }


  inputChangeAmount = (event) => {
    event.preventDefault();
    let { users } = this.props;
    let { overview } = users;
    let { setting } = overview;
    let { txFee } = setting ? setting : {};
    // console.log("event.target.value  ", event.target.value);
    if (event.target.value >= 0) {
      const { fieldslogin, errorslogin } = this.state;
      fieldslogin[event.target.name] = event.target.value;
      fieldslogin['amount'] = event.target.value;
      fieldslogin['fees'] = txFee ? txFee : 0.0001;
      fieldslogin['recievingAmount'] = parseFloat(event.target.value - (txFee ? txFee : 0.0001)).toFixed(8);
      errorslogin['amount'] = "";
      this.setState({ fieldslogin, errorslogin });
    } else {
      const { errorslogin } = this.state;
      errorslogin['amount'] = "Amount should be positive number.";
      this.setState({ errorslogin });
    }
  }

  copyCodeToClipboard = (data) => {
    navigator.clipboard.writeText(data)
    this.props.dispatch(alertActions.success("Copied!"));
  }

  handlePageChange = (offset, page) => {
    // console.log(offset, page)
  }

  inputChangePrice = (event) => {
    let { users } = this.props;
    let { priceDeta } = users;
    let { btcPrice, dollerPrice } = priceDeta ? priceDeta : {}
    event.preventDefault();
    const { priceTempData } = this.state;
    priceTempData[event.target.name] = event.target.value;
    priceTempData['dollerPrice'] = parseFloat(event.target.value * dollerPrice).toFixed(8);
    priceTempData['btcPrice'] = parseFloat(event.target.value * btcPrice).toFixed(8);
    this.setState({ priceTempData });
    // BPC: 1,
    //     btcPrice: 0,
    //     dollerPrice: 0,
  }
  // handlePageClick = (data) => {
  //   let offset = Math.ceil(data.selected * this.state.size);
  //   this.setState({ offset: offset, page: data.selected });
  //   let datatemp = {
  //     "keyWord": this.state.keyWord,
  //     "pageNo": data.selected + 1,
  //     "size": this.state.size
  //   }
  //   this.props.dispatch(hospitalActions.getHospitalDrList(datatemp));
  // }

  handleSearch = (event) => {
    event.preventDefault();
    let { value } = event.target;
    this.setState({ keyWord: value, offset: 0 });
    let data = {
      "txType": "SEND_RECEIVED",
      "keyWord": value,
      "pageNo": 1,
      "size": this.state.size
    }
    this.props.dispatch(userActions.getTx(data));
  }

  exportPDF = () => {
    let { users } = this.props;

    let { txList } = users;
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    const title = "Send and Received Report";
    const headers = [["DATE", "TRANSACTION TYPE", "AMOUNT", "COIN", "TRANSACTION STATUS"]];
    const data = txList.map(elt => [moment(new Date(parseInt(elt.createdAt))).utcOffset("+05:30").format("YYYY-MM-DD HH:mm"), elt.txType, elt.amount, elt.coin, elt.status ? "SUCESS" : "PENDING"]);

    let content = {
      startY: 50,
      head: headers,
      body: data
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save(Date.now() + "_send_received_report.pdf")
  }

  onClickMenu = (url) => {
    this.props.history.push(url)
  }



  handleValidationUserInfo = () => {
    let fieldsUser = this.state.fieldsUser;
    let errorslogin = {};
    let formIsValid = true;

    // name
    if (!fieldsUser["name"]) {
      formIsValid = false;
      errorslogin["name"] = "Invalid Name!";
    }

    // title
    if (!fieldsUser["title"]) {
      formIsValid = false;
      errorslogin["title"] = "Invalid Title!";
    }

    // mobNo
    if (!fieldsUser["mobNo"]) {
      formIsValid = false;
      errorslogin["mobNo"] = "Invalid Mobile Number!";
    }

    // alternateNo
    if (!fieldsUser["alternateNo"]) {
      formIsValid = false;
      errorslogin["alternateNo"] = "Invalid Alternate Number!";
    }

    // profileImg
    if (!fieldsUser["profileImg"]) {
      formIsValid = false;
      errorslogin["profileImg"] = "Invalid Profile Image URL!";
    }

    // aboutUs
    if (!fieldsUser["aboutUs"]) {
      formIsValid = false;
      errorslogin["aboutUs"] = "Invalid About Us!";
    }

    this.setState({ errorslogin: errorslogin });
    return formIsValid;
  };






  inputChange = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    // this.setState({ [name]: value });
    let fieldsUser = this.state.fieldsUser;
    let errorslogin = this.state.errorslogin;
    fieldsUser[name] = value;
    errorslogin[name] = "";
    // console.log(name, value);
    this.setState({ fieldsUser, errorslogin });

  }


  AddHospitalDr = (e) => {
    console.log(this.state.fieldsUser)
    if (this.handleValidationUserInfo()) {
      let data = {
        name: this.state.fieldsUser.name,//oldPassword
        title: this.state.fieldsUser.title,
        mobNo: this.state.fieldsUser.mobNo,//newpassword
        alternateNo: this.state.fieldsUser.alternateNo,
        profileImg: this.state.fieldsUser.profileImg,
        specializationId: this.state.fieldsUser.specializationId,
        aboutUs: this.state.fieldsUser.aboutUs,
      }
      console.log("updatePasswordSubmit___updatePasswordSubmit:::", data);
      this.props.dispatch(hospitalActions.addHospitalDr(data, this.props));
      this.setState({
        fieldsUser: {
          name: "",
          title: "",
          mobNo: "",
          alternateNo: "",
          profileImg: "",
          specializationId: "",
          aboutUs: "",
        },
        errorslogin: {}, // Optionally, you can reset errors as well
      });
    }


  }


  showAddDoctor = () => {

    this.setState((prevState) => ({
      addDocotor: !prevState.addDocotor,
    }));
    console.log(this.state.addDocotor)
  }


  closeDrModel = () => {
    this.setState((e) => ({
      open: !e.open
    }))
    this.props.dispatch(hospitalActions.uploadImageClear())
    this.props.dispatch(hospitalActions.clearimage())
  }




  handleUpdate = (data) => {

    this.setState({ open: true, modelData: data })
  }

  deleteDoctor = (data) => {
    confirmAlert({
      title: 'Confirm to submit?',
      message: 'Are you sure you want to delete the doctor?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {

            this.props.dispatch(hospitalActions.deleteHospitalDr({ id: data.id }));


          }
        },
        {
          label: 'No'
        }
      ]
    });
  }

  closeviewmore = () => {
    this.setState((e) => ({
      viewmore: !e.viewmore
    }))
  }



  viewModeOpen = (data) => {

    this.setState({ viewmore: true, modelData: data })
  }


  render() {

    let { users, user, dashboard, hospital } = this.props;
    let { overview } = users;
    let { loading, DoctorList,hospitalData } = hospital;
    let { list, total } = DoctorList ? DoctorList : {};

    console.log("RENDER_________teamLastLevel::",hospitalData);

    return (
      <div className='  flex relative'>

{ hospitalData?.isDisable&& <div className=' bg-red-600 z-50   text-center justify-center items-center flex text-white absolute w-full'>Your Account has been Suspended by Admin , For more Info Contact to <a className=' ml-2' href="mailto:support@urphysio.in">support@urphysio.in</a></div>}

        <UpdateDrModel open={this.state.open} closeDrModel={this.closeDrModel} modelData={this.state.modelData} />
        <div className=''>
          <HospitalSidebar />
          <ViewMoreModel viewmore={this.state.viewmore} closeviewmore={this.closeviewmore} modelData={this.state.modelData} />
        </div>
        <div className=' h-[90vh] overflow-y-auto overflow-hidden  pb-1  w-full'>

          <section className=''>

            <div className=''>
              <div >
                <LoadingOverlay
                  active={loading}
                  className="temp001"
                  spinner
                  text='Please wait...' />
              </div>

              <AddDoctorModel addDocotor={this.state.addDocotor} closeDialog={this.showAddDoctor} />

              <div className='w-11/12 grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6 md:p-10 p-2 mx-auto'>
                <div onClick={this.showAddDoctor} className='w-full h-28 justify-center items-center flex text-white text-xl rounded-md bg-[#005F60] cursor-pointer'>Add Doctor</div>
                <div onClick={() => this.onClickMenu('/app/hospital/reviewRating')} className='w-full h-28 justify-center items-center flex text-white text-xl rounded-md bg-[#005F60] cursor-pointer'>Review Rating</div>
                <div onClick={() => this.onClickMenu('/app/hospital/subscription')} className='w-full h-28 justify-center items-center flex text-white text-xl rounded-md bg-[#005F60] cursor-pointer'>Subscription</div>
                {/* <div onClick={() => this.onClickMenu('/app/hospital/treatment')} className='w-full h-28 justify-center items-center flex text-white text-xl rounded-md bg-[#005F60] cursor-pointer'>Treatement</div> */}

              </div>
            </div>
          </section>

          <div className='w-11/12 mx-auto  overflow-x-hidden overflow-auto md:px-10 px-2 pb-20'>


            {list?.map((row) => (<>
              <div className=' cursor-pointer border-b border-gray-600 p-3  mb-3 hover:scale-[1.01] transition-all ease-in-out  shadow-md shadow-[#005f60] m-2 rounded-lg'>
                <div className='flex xl:justify-between flex-col xl:flex-row xl:space-y-0 space-y-4'>
                  <div className='md:flex md:space-x-10 space-x-0 md:space-y-0 space-y-4'>
                    <img className=' md:w-36 md:h-36 w-full md:rounded-full' src={row?.imageLinkUrl || 'https://cdn-icons-png.freepik.com/256/3135/3135715.png?ga=GA1.1.1346393448.1707470564'} />
                    <div className='flex flex-col gap-3'>
                      <p className=' text-lg font-bold'>
                        Name :  <span className='text-md font-semibold'>{row?.title}{row?.name}</span>
                      </p>
                      <p className=' text-lg font-bold'>
                        Mobile no : <span className='text-md font-semibold'>{row?.mobNo}</span>
                      </p>
                      <p className=' text-lg font-bold'>
                        Experience : <span className='text-md font-semibold'>{row?.expireance || "--"}</span>
                      </p>
                      {/* <p className=' text-lg font-bold'>
                        Specialization : <span className='text-md font-semibold'>{row?.specializationId?.name || "--"}</span>
                      </p> */}

                    </div>
                  </div>
                  <div className='flex justify-evenly items-center xl:flex-col'>
                    <div>
                      <button
                        onClick={() => this.handleUpdate(row)}
                        className="bg-[#005F60] text-white font-bold py-2 px-4 rounded shadow-md md:w-40 text-center md:block hidden "
                        variant="contained"
                      >
                        Update Doctor
                      </button>
                      <button
                        onClick={() => this.handleUpdate(row)}
                        className="bg-[#005F60] text-white font-bold py-2 px-4 rounded shadow-md md:w-40 md:hidden flex "
                        variant="contained"
                      >
                        <FaRegEdit />
                      </button>
                    </div>
                    <div>
                      <button
                        className="bg-pink-500  text-white font-bold py-2 px-4 rounded shadow-md md:w-40 text-center md:block hidden"
                        onClick={() => this.deleteDoctor(row)}
                      >
                        Delete Doctor
                      </button>
                      <button
                        onClick={() => this.deleteDoctor(row)}
                        className="bg-[#005F60] text-white font-bold py-2 px-4 rounded shadow-md md:w-40 md:hidden flex "
                        variant="contained"
                      >
                        <MdDelete />
                      </button>
                    </div>
                    <div>
                      <button
                        className="bg-[#95CCC5]  text-[#005F60] font-bold py-2 px-4 rounded shadow-md md:w-40 text-center md:block hidden"
                        onClick={() => this.viewModeOpen(row)}
                      >
                        View More
                      </button>
                      <button
                        onClick={() => this.viewModeOpen(row)}
                        className="bg-[#005F60] text-white font-bold py-2 px-4 rounded shadow-md md:w-40 md:hidden flex "
                        variant="contained"
                      >
                        <BsThreeDots />
                      </button>
                    </div>

                  </div>
                </div>
              </div >
            </>

            ))}

            {
              isMobile ?
                <nav className="relative z-0 flex justify-end mt-2 w-76">
                  {
                    list && list.length && list && list.length > 10 ?
                      <ReactPaginate
                        previousLabel={'Prev'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={list && list.length / this.state.size}
                        marginPagesDisplayed={1}
                        pageRangeDisplayed={1}
                        onPageChange={this.handlePageClick}
                        containerClassName={'pagination'}
                        pageClassName={'page-cls'}
                        activeClassName={'active'}
                      />
                      : null}
                </nav> : <nav className="relative z-0 flex justify-end mt-2 w-76">
                  {
                    list && list.length && list && list.length > 10 ?
                      <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={list && list.length / this.state.size}
                        marginPagesDisplayed={3}
                        pageRangeDisplayed={3}
                        onPageChange={this.handlePageClick}
                        containerClassName={'pagination'}
                        pageClassName={'page-cls'}
                        activeClassName={'active'}
                      />
                      : null}
                </nav>
            }

          </div>



        </div>
      </div >
    );
  }

}




function mapStateToProps(state) {
  const { users, dashboard, hospital } = state;
  const { overview } = users ? users : {};
  const { setting, user, wallet } = overview ? overview : {};
  // console.log("mapStateToProps______________dashboard::", dashboard);
  return {
    users,
    setting,
    user,
    dashboard,
    wallet,
    hospital
  };
}
export default connect(mapStateToProps)(HospitalDashboard);